import consts from '../consts';
import Model from '../models/model';

const model = new Model({
	name: 'TransactionInfo',
	defaultSort: 'EquipmentName',
	readOnly: true,
	disableAdd: true,
	title: 'Transaction',
	showGridRefreshBtn: true,
	columns: [
		{ header: 'Unique Id', field: 'TransactionInfoId', hidden: true, width: 140, isNotExportField: true },
		{ header: 'Equipment Name', field: 'EquipmentName', width: 140 },
		{ header: 'Equipment Type', field: 'EquipmentType', width: 140 },
		{ header: 'Model', field: 'Model', width: 140 },
		{ header: 'Cycle Name', field: 'CycleName', width: 140 },
		{ header: 'Cycle Count', field: 'CycleNumber', width: 110, type: 'int' },
		{ header: 'Cycle Status', field: 'Status', width: 120 },
		{
			header: 'Cycle Date',
			field: 'CycleDate',
			type: 'date',
			width: 160,
			format: consts.MomentFormat.DateTimeFormatNoSecsAMPM
		},
		{ header: 'Hanger / Storage Unit', field: 'Hanger', type: 'int', width: 120 },
		{ header: 'Message', field: 'Message', width: 400, pdfExportWidth: 450 },
		{ header: 'Detail', field: 'RawContent', width: 640, hidden: true, isNotExportField: true, pdfExportWidth: 450 }
	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A1'
		}
	}
});

export default model.createFormBase();
